import Cookies from "./Cookies";

export default class InfoBar {

    static init() {
        InfoBar.handleClose();

        let current = 0,
            column = document.querySelector('.info-bar .col'),
            slides = document.querySelectorAll('.info-bar__info');

        if (slides.length > 0) {
            let maxHeight = 0;
            slides.forEach( slide => {
                if (slide.clientHeight > maxHeight) {
                    maxHeight = slide.clientHeight;
                }
            });
            if (column) {
                column.style.minHeight = `${maxHeight + 12}px`;
            }
            setInterval(function() {
                for (let i = 0; i < slides.length; i++) {
                    slides[i].style.opacity = 0;
                    slides[current].classList.remove('active');
                }
                current = (current !== slides.length - 1) ? current + 1 : 0;
                slides[current].style.opacity = 1;
                slides[current].classList.add('active');
            }, 3000);
        }
    }

    static handleClose() {
        const infoBar = document.getElementById('jsInfoBar');
        const infoBarHandler = document.getElementById('jsInfoBarHandler');

        if (infoBar && infoBarHandler) {
            infoBarHandler.addEventListener('click', () => {
                infoBar.classList.add('info-bar--closed');
                let currentSlide = document.querySelector('.info-bar__info.active');
                Cookies.setCookie('notification-'+currentSlide.dataset.id, 1, 1);
            });
        }
    }
}
